import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const SendHorizonal: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'm3 3 3 9-3 9 19-9Z' }],
    ['path', { d: 'M6 12h16' }],
  ],
];

export default SendHorizonal;
